<template lang="pug">
    #invoice-content
        .d-flex.justify-center
            #invoice-preview-page
                v-row.invoice-header.ma-md-3
                    //- v-col(cols="6")
                    //-     v-img(src="@/assets/logo.png" height="184" width="612" )
                    v-col.text-left(cols="12" md="6")
                        .invoice-title {{invoice.name}}
                        .invoice-subtitle {{invoice.subHeader}}
                        .business(v-if="invoice.business")
                            .company-name {{invoice.business.name}}
                            .company-address 
                                span(v-if="invoice.business.billingAddress != null && invoice.business.billingAddress != ''") {{invoice.business.billingAddress}},
                                span(v-if="getCountryName(invoice.business.countryCode) != ''")  {{getCountryName(invoice.business.countryCode)}}
                            .company-email {{invoice.business.email}}
                            .company-phone {{invoice.business.phone}}
                v-divider
                v-row.invoice-info.ma-md-3(justify="space-between")
                    v-col(md="6" xs="12")
                        .customer(v-if="invoice.customer")
                            .customer-title Bill to
                            .customer-name {{invoice.customer.name}}
                            .customer-phone {{invoice.customer.phone}}
                            .customer-email {{invoice.customer.email}}
                    v-col(md="6" xs="12")
                        v-simple-table.info-table(dense v-slot:default)
                            tbody 
                                tr.no-border.no-hover
                                    td.left-col {{$t('EstimatesAndInvoices.__No')}}
                                    td.right-col {{invoice.number}}
                                tr.no-border.no-hover
                                    td.left-col P.O. / S.O. {{$t('EstimatesAndInvoices.__No')}}
                                    td.right-col {{invoice.poso}}
                                tr.no-border.no-hover
                                    td.left-col {{$t('EstimatesAndInvoices.__InvoiceDate')}}
                                    td.right-col {{invoice.issuedAt}}
                                tr.no-border.no-hover
                                    td.left-col {{$t('EstimatesAndInvoices.__InvoiceDueOn')}}
                                    td.right-col {{invoice.expiredAt}}
                                tr.no-border(style="background-color:#fdf1ec")
                                    td.left-col {{$t('EstimatesAndInvoices.__Total')}} ({{currency? currency.code : ''}})
                                    td.right-col {{getAmountWithCurrency(invoice.amount, invoice.currencyCode)}}
                v-row.invoice-content.ma-md-3
                    v-col.d-md-none.d-print-none(cols="12")
                        v-simple-table(dense)
                            thead(style="background-color:#fae3d8")
                                tr.no-hover
                                    th {{$t('EstimatesAndInvoices.__Item')}}
                            tbody
                                template(v-for="item in invoice.items")
                                    tr
                                        td.py-2
                                            v-row.no-hover
                                                v-col.py-2
                                                    .product-name {{item.name}}
                                                    .product-description {{item.description}}
                                            v-row
                                                v-col.py-0.grey--text  {{$t('EstimatesAndInvoices.__Quantity')}}
                                                v-col.py-0.text-right.product-quantity {{item.quantity}}
                                            v-row
                                                v-col.py-0.grey--text {{$t('EstimatesAndInvoices.__Price')}}
                                                v-col.py-0.text-right.product-price  {{getAmountWithCurrency(item.price, invoice.currencyCode)}}
                                            v-row
                                                v-col.py-0.grey--text {{$t('EstimatesAndInvoices.__Amount')}}
                                                v-col.py-0.text-right.product-total {{getAmountWithCurrency(item.price*item.quantity, invoice.currencyCode)}}
                                                    .tax-area
                                                        .tax-amount(v-for="tax in item.taxes")
                                                            span.tax-name.mr-2 {{tax.abbreviation}}
                                                            span {{getAmountWithCurrency(tax.amount, invoice.currencyCode)}}

                                tr.no-hover(v-if="invoice.memo")
                                    td.pt-6.invoice-memo(colspan="2" style="vertical-align: top") {{invoice.memo}}
                                tr.no-hover
                                    td.pt-6.text-right.pr-0(colspan="2" style="vertical-align: top")
                                        v-simple-table(dense)
                                            tr.no-hover.subtotal
                                                td.font-weight-bold.mr-10 {{$t('EstimatesAndInvoices.__Subtotal')}}
                                                td {{getAmountWithCurrency(invoice.subtotal, invoice.currencyCode)}}
                                            tr.no-hover.taxtotal(v-for="tax in invoice.taxes")
                                                td.font-weight-bold.mr-10 {{tax.abbreviation}}
                                                td {{getAmountWithCurrency(tax.amount, invoice.currencyCode)}}
                                            tr.no-hover.total
                                                td.font-weight-bold.mr-10 {{$t('EstimatesAndInvoices.__Total')}}
                                                td {{getAmountWithCurrency(invoice.amount, invoice.currencyCode)}}
                                            tr.amount-due(v-if="invoice.paid != null" style="background-color:#fdf1ec")
                                                td.font-weight-bold.mr-10 {{$t('EstimatesAndInvoices.__OutstandingPayment')}} ({{currency? currency.code : ''}})
                                                td {{getAmountWithCurrency(invoice.amount - invoice.paid, invoice.currencyCode)}}

                    v-col.d-none.d-md-block.d-print-block(cols="12")
                        v-simple-table(dense)
                            template(v-slot:default)
                                thead(style="background-color:#fae3d8")
                                    tr.no-hover
                                        th(width="40%") {{$t('EstimatesAndInvoices.__Item')}}
                                        th(width="10%") {{$t('EstimatesAndInvoices.__Quantity')}}
                                        th.text-right {{$t('EstimatesAndInvoices.__Price')}}
                                        th.text-right {{$t('EstimatesAndInvoices.__Amount')}}
                                tbody
                                    tr.no-hover(v-for="item in invoice.items")
                                        td 
                                            .product-name {{item.name}}
                                            .product-description {{item.description}}
                                        td.product-quantity {{item.quantity}}
                                        td.product-price.text-right {{getAmountWithCurrency(item.price, invoice.currencyCode)}}
                                        td.product-total.text-right {{getAmountWithCurrency(item.price*item.quantity, invoice.currencyCode)}}
                                            .tax-area
                                                .tax-amount(v-for="tax in item.taxes")
                                                    span.tax-name.mr-2 {{tax.abbreviation}}
                                                    span {{getAmountWithCurrency(tax.amount, invoice.currencyCode)}}
                                    tr.no-hover
                                        td.pt-6.invoice-memo(colspan="2" style="vertical-align: top") {{invoice.memo}}
                                        td.pt-6.text-right.pr-0(colspan="2" style="vertical-align: top")
                                            v-simple-table(dense)
                                                tr.no-hover.subtotal
                                                    td.font-weight-bold.mr-10 {{$t('EstimatesAndInvoices.__Subtotal')}}
                                                    td {{getAmountWithCurrency(invoice.subtotal, invoice.currencyCode)}}
                                                tr.no-hover.taxtotal(v-for="tax in invoice.taxes")
                                                    td.font-weight-bold.mr-10 {{tax.abbreviation}}
                                                    td {{getAmountWithCurrency(tax.amount, invoice.currencyCode)}}
                                                tr.no-hover.total
                                                    td.font-weight-bold.mr-10 {{$t('EstimatesAndInvoices.__Total')}}
                                                    td {{getAmountWithCurrency(invoice.amount, invoice.currencyCode)}}
                                                tr.amount-due(v-if="invoice.paid != null" style="background-color:#fdf1ec")
                                                    td.font-weight-bold.mr-10 {{$t('EstimatesAndInvoices.__OutstandingPayment')}} ({{currency? currency.code : ''}})
                                                    td {{getAmountWithCurrency(invoice.amount - invoice.paid, invoice.currencyCode)}}
                                        
        v-row.invoice-footer.ma-3.mt-10
            v-col.text-center(cols="12") {{invoice.footer}}
</template>

<script>
import * as currencyHelper from "@/utils/currencies.js"
import * as countryHelper from "@/utils/countries.js"

import * as PDF from "@/utils/pdf"

export default {
  mixins: [currencyHelper.mixin, countryHelper.mixin],
  props: {
    data: {
      type: Object,
      default: () => {
        return null
      }
    },
    invoiceId: {
      type: String
    },
    exportType: {
      type: String,
      default: "default"
    },
    isShared: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      invoice: { items: [] },
      currency: {
        symbol: "NT$",
        code: "TWD",
        name: "Taiwan New Dollar",
        id: 206
      }
    }
  },
  computed: {},
  watch: {
    data() {
      this.invoice = this.data
      // this.invoice.business = this.$store.getters["bizes/biz"]()
      this.updateAmount()
    },
    invoice() {
      this.currency = this.getCurrency(this.invoice.currencyCode)
      document.title = this.invoice.name + "-" + this.invoice.number
    },
    invoiceId() {
      this.getInvoice(this.invoiceId, this.exportType)
    }
  },
  methods: {
    print() {
      window.print()
      this.$router.go(-1)
    },
    getInvoice(id, type) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/getInvoice", id)
        .then(
          function(response) {
            this.invoice = response.data
            this.invoice.business = this.$store.getters["bizes/biz"]()

            this.$emit("invoice-updated", this.invoice)
            this.updateAmount()
            if (type == "print") {
              setTimeout(
                function() {
                  this.print()
                }.bind(this),
                1000
              )
            } else if (type == "download") {
              setTimeout(
                function() {
                  this.downloadPDF()
                }.bind(this),
                1000
              )
            }

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    getSharedInvoice(id, type) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/getShareInvoice", id)
        .then(
          function(response) {
            this.invoice = response.data
            this.$emit("invoice-updated", this.invoice)
            this.updateAmount()
            if (type == "print") {
              setTimeout(
                function() {
                  this.print()
                }.bind(this),
                1000
              )
            }

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$router.push("/" + this.$i18n.locale + "/404")
          }.bind(this)
        )
    },
    updateAmount() {
      var subtotal = 0
      if (this.invoice.items) {
        for (var item of this.invoice.items) {
          subtotal += item.price * item.quantity
        }
        this.invoice.subtotal = subtotal
      }
    },
    downloadPDF() {
      PDF.download("#invoice-preview-page", this.invoice.name + "_" + this.invoice.number, () => {
        this.$router.go(-1)
      })
    }
  },
  mounted() {
    if (this.exportType == "download") {
      var element = document.getElementById("invoice-content")
      element.classList.add("pdf-view")
    }
  },
  created() {
    if (this.data == null) {
      if (this.$route.name == "InvoiceCustomerView") {
        this.getInvoice(this.invoiceId, this.exportType)
      } else if (this.$route.name == "SharedInvoiceView") {
        this.getSharedInvoice(this.invoiceId, this.exportType)
      } else if (this.$route.name == "InvoiceExport") {
        if (this.isShared) {
          this.getSharedInvoice(this.invoiceId, this.exportType)
        } else {
          this.getInvoice(this.invoiceId, this.exportType)
        }
      }
    } else {
      this.invoice = this.data
      this.updateAmount()
      if (this.exportType == "download") {
        setTimeout(
          function() {
            this.downloadPDF()
          }.bind(this),
          1000
        )
      } else if (this.exportType == "print") {
        setTimeout(
          function() {
            this.print()
          }.bind(this),
          1000
        )
      }
    }
    // this.company = this.$store.getters["bizes/biz"]()
  }
}
</script>
<style lang="scss" scoped>
#invoice-preview-page {
  -webkit-print-color-adjust: exact;
  width: 100%;
}
.invoice-footer {
  font-size: 16px;
  color: #b4b9be;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
.invoice-info {
  line-height: 2;
  .customer-title {
    color: #b4b9be;
    font-size: 13px;
    opacity: 0.8;
  }
  .customer-name {
    font-size: 16px;
    color: #1e1e21;
  }

  .customer-phone,
  .customer-email {
    color: #505356;
    font-size: 13px;
    opacity: 0.8;
  }

  .info-table {
    font-size: 13px;
    line-height: 1.5;
    td.left-col {
      opacity: 0.8;
      text-align: right;
      color: #505356;
    }
    td.right-col {
      color: #000000;
    }
  }
}

.invoice-content {
  // td {
  //     height: 78px;
  // }
  .product-name,
  .product-price,
  .product-total,
  .product-quantity,
  .subtotal,
  .taxtotal,
  .total,
  .amount-due {
    font-size: 16px;
    color: #1e1e21;
    line-height: 1.5;
  }

  tr.total {
    td {
      border-top: thin solid rgba(0, 0, 0, 0.12);
    }
  }

  .product-description,
  .invoice-memo {
    opacity: 0.8;
    font-size: 13px;
    color: #505356;
  }

  .tax-area {
    font-size: 13px;
    opacity: 0.8;
  }
}

.invoice-header {
  font-family: NotoSansCJKtc;
  line-height: 1.25;
  .invoice-title {
    font-size: 33px;
    font-weight: bold;
    color: #505356;
    margin-bottom: 16px;
  }
  .invoice-subtitle {
    font-size: 16px;
    color: #b4b9be;
    margin-bottom: 36px;
  }
  .company-name {
    font-size: 16px;
    font-weight: normal;
    color: #1e1e21;
    margin-bottom: 8px;
  }
  .company-address,
  .company-country,
  .company-email,
  .company-phone {
    opacity: 0.8;
    font-size: 13px;
    color: #505356;
    margin-bottom: 8px;
  }
}
</style>
